import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GasInputFieldComponent } from './field/gas-input-field.component';
import { GasInputWrapperComponent } from './wrapper/gas-input-wrapper.component';
import { GasInputLabelComponent } from './label/gas-input-label.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasInputComponent } from './input/gas-input.component';
import { GasInputErrorComponent } from './error/gas-input-error.component';

const COMPONENTS = [
  GasInputFieldComponent,
  GasInputWrapperComponent,
  GasInputLabelComponent,
  GasInputErrorComponent,
  GasInputComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GasIconsModule,
  ],
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
})
export class GasInputModule { }
